import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import _ from 'lodash'
import cx from 'classnames'
import Modal from 'react-modal'

import Portal from './../../../components/Portal';
import { WidgetsContext } from  '../core';
import BrandThemeManager from '../../Theme';
import { HotspotRender } from '../../../components/hotspot';

import { ParallaxProvider } from "react-scroll-parallax";

import {
  Button
} from 'react-bootstrap';

import { ModalContext } from '../core'
import { BackgroundView } from '../background';

import styles from './modal.module.scss'

const ModalWidgetComponent = ({ className, style, widgetProps, breakpoint, children, show }) => {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const [zoom, setZoom] = useState(1);

  const context = React.useContext(WidgetsContext);

  if(context.development) {
    return <ModalDeviceRender
      className={className}
      style={style}
      widgetProps={widgetProps}
      breakpoint={breakpoint}
      children={children}
      show={show}
    />
  }

  const modalContext = React.useContext(ModalContext);
  const [backdropContainer, setBackdropContainer] = React.useState(null);
  const close = _.get(modalContext, 'close', null);

  const properties = _.get(widgetProps, 'properties', {});
  const background = _.get(widgetProps, 'properties.desktop.background');
  const backdrop = _.get(widgetProps, 'properties.desktop.backdrop');

  const layout = _.get(widgetProps, `properties.${breakpoint}.layout`, {});
  const layoutWidth = parseInt(_.get(layout, 'width', '1200'));

  var modalWidgetStyle = {
    content: {
      width: style.width,
      transform: `scale(${zoom})`
    }
  }

  var modalContainerStyle = {
    ...style,
    ...getModalStyles(properties),
    transform: 'none'
  }

  useEffect(() => {
    calculateZoom();
    window.addEventListener('resize', calculateZoom);
    return () => {
      window.removeEventListener('resize', calculateZoom);
    }
  }, [breakpoint, layoutWidth]);

  const handleClose = () => {
    if(close) {
      close();
    }
  }

  const onAfterOpen = () => {
    let container = document.getElementsByClassName('cs-modal-overlay');
    if(container && container.length > 0) {
      setBackdropContainer(container[0]);
    }
  }

  const calculateZoom = () => {
    const windowWidth = window.innerWidth;

    var zoomValue = 1;
    if (layoutWidth > windowWidth) {
      zoomValue = windowWidth / layoutWidth;
    }

    setZoom(zoomValue);
  }


  return (
    <Modal
      id={id}
      className={cx(className, styles.modalWidget, 'cs_modal_widget', {
        [styles.mobile]: breakpoint === 'mobile'
      })}
      overlayClassName={cx(styles.modalOverlay, 'cs-modal-overlay')}
      style={modalWidgetStyle}
      data-widget-id={id}
      data-widget-type={type}
      isOpen={show}
      ariaHideApp={false}
      onAfterOpen={onAfterOpen}
    >
      <HotspotRender breakpoint={breakpoint}>
        <div className={styles.modalContainer}
          style={modalContainerStyle}
        >
          <BrandThemeManager className={`#${id} .cs_text_widget`} themes={widgetProps.themes} />
          <BackgroundView background={background} className={styles.modalBackground} breakpoint={breakpoint} />
          {backdropContainer &&
            <Portal mountNode={backdropContainer}>
              <BackgroundView background={backdrop} className={styles.overlayBackground} breakpoint={breakpoint} />
            </Portal>
          }

          {close &&
            <Button className={styles.close} onClick={handleClose}>
              <i className={cx(styles.closeIcon, 'cleverstory-close')} />
            </Button>
          }
          <ParallaxProvider>
            {children}
          </ParallaxProvider>
        </div>
      </HotspotRender>
    </Modal>
  )
}


const ModalDeviceRender = ({ className, style, widgetProps, breakpoint, children, show }) => {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  const properties = _.get(widgetProps, 'properties', {});
  const background = _.get(widgetProps, 'properties.desktop.background');

  var widgetStyle = {
    ...style,
    ...getModalStyles(properties),
    transform: 'none'
  }

  return (
    <div id={id}
      className={cx(className, styles.modalDeviceRender, 'cs_modal_widget', {
        [styles.mobile]: breakpoint === 'mobile'
      })}
      style={widgetStyle}
      data-widget-id={id}
      data-widget-type={type}
    >
      <BackgroundView background={background} className={styles.modalBackground} breakpoint={breakpoint} />
      <div className={styles.modalContainer}>
        {children}
      </div>
    </div>
  )
}

function getModalStyles(properties) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = _.get(properties, `desktop`);

  const border = _.get(defaultProperties, 'border');
  const borderStyles = getBorderStyles(border);

  styles = {
    ...styles,
    ...borderStyles
  }

  return styles;
}

export function getBorderStyles(border) {
  var styles = {};
  if (!border) {
    return styles;
  }

  const topLeft = _.get(border, 'radius.topLeft', null);
  const topRight = _.get(border, 'radius.topRight', null);
  const bottomLeft = _.get(border, 'radius.bottomLeft', null);
  const bottomRight = _.get(border, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  const borderStyle = _.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {

    const colorRgb = _.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
    }

    styles['borderColor'] = color;

    const borderWidthString = _.get(border, 'width', 0);
    var borderWidget = parseInt(borderWidthString) + 'px';

    styles['borderWidth'] = borderWidget;
  }

  return styles;
}

const modalWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const ModalWidget = React.memo(ModalWidgetComponent, modalWidgetEquals);
